import { memo } from 'react';
import styles from './FJSourceReviewItemStatus.module.less';
import PropTypes from 'prop-types';
import FJConstant from '../../../constants/FJConstant';
import FJLocalStore from '../../../store/FJLocalStore';
import FJUtil from '../../../util/FJUtil';
import ReloadIcon from '../../../assets/svg/reload.svg?react';
import FJResourceItemLoading from '../../../common/components/FJResourceItemLoading/FJResourceItemLoading';

// data 用于处理特殊需求下需要的数据
const FJSourceReviewItemStatus = memo(({ status, data, onRetry, onSourceReload }) => {
    const _onRetry = e => {
        e.stopPropagation();
        onRetry && onRetry();
    };

    const _onSourceReload = e => {
        e.stopPropagation();
        onSourceReload && onSourceReload();
    };

    return (
        <>
            {status === FJConstant.PROGRESS &&
                (() => {
                    const { generationType, originalUrl } = data;

                    return (
                        <div className={styles.wait_box}>
                            {generationType === 'iv' && originalUrl && (
                                <>
                                    <img className={styles.bk_img} src={originalUrl} alt='' />
                                    <div className={styles.mask} />
                                </>
                            )}
                            <div className={styles.content}>
                                <div className={styles.wait_title}>{FJLocalStore._('generating_')}</div>
                                <div
                                    className={styles.wait_desc}
                                    dangerouslySetInnerHTML={{ __html: FJLocalStore._('estimate-wait-time') }}
                                />
                            </div>
                        </div>
                    );
                })()}

            {(status === FJConstant.ERROR || status === FJConstant.RETRY) &&
                (() => {
                    const isVideoGenerator = FJUtil.isVideoGenerator();
                    return (
                        <div className={styles.new_retry_box}>
                            {isVideoGenerator && (
                                <div className={styles.error_text}>
                                    {FJLocalStore._('failed-to-generate-video-because-of-some-unknown-errors')}
                                </div>
                            )}
                            <div className={styles.retry_btn} onClick={_onRetry}>
                                {FJLocalStore._('retry')}
                            </div>
                        </div>
                    );
                })()}

            {status === FJConstant.LOADING && <FJResourceItemLoading className={styles.loading} />}

            {/* 资源加载失败 */}
            {status === FJConstant.SOURCE_LOADING_ERROR &&
                (() => {
                    return (
                        <div className={styles.retry_box}>
                            <ReloadIcon className={styles.reload_icon} onClick={_onSourceReload} />
                        </div>
                    );
                })()}
        </>
    );
});

FJSourceReviewItemStatus.displayName = 'FJSourceReviewItemStatus';

FJSourceReviewItemStatus.propTypes = {
    status: PropTypes.string.isRequired,
    data: PropTypes.object,
    onRetry: PropTypes.func,
    onSourceReload: PropTypes.func,
};

export default FJSourceReviewItemStatus;
